import React from 'react';

import { observer } from 'mobx-react-lite';
import { LoreType } from 'stores/lore_store';
import useStores from 'hooks/useStores';


type LoreContextType = {

    // createLore: (identity: string, associated_type: string, associated_uuid: string) => Promise<LoreType>;

    // Fetch and get one
    fetchBySlug: (identity: string, uuid: string) => Promise<LoreType | null>;
    getBySlug: (uuid: string) => LoreType | null;

}

export const LoreContext = React.createContext<LoreContextType>({
    fetchBySlug: () => { throw 'Not Implemented' },
    getBySlug: () => { throw 'Not Implemented' },
});


export const LoreProvider = observer(({ children }: { children: React.ReactNode }) => {
    const { loreStore } = useStores();

    const fetchBySlug = async (identity: string, slug: string) => {

        return loreStore.fetchBySlug(identity, slug)
            .then((doc) => {
                return doc;
            });
    };

    const getBySlug = (slug: string) => {
        return loreStore.items.slice().find((item) => item.slug === slug) || null;
    };

    const data = {
        fetchBySlug,
        getBySlug
    };

    return (
        <LoreContext.Provider value={data}>{ children }</LoreContext.Provider>
    );

});
